module.exports = __webpack_public_path__ + "img/banner6.7a7983a6.jpg";